/* eslint-disable no-confusing-arrow */
import { merge } from 'ramda';

import Utils from 'src/utils';
import {
  LOAD_PROFESSIONS_REQUEST, LOAD_PROFESSIONS_SUCCESS, LOAD_PROFESSIONS_FAIL,
  POST_PROFESSIONS_REQUEST, POST_PROFESSIONS_SUCCESS, POST_PROFESSIONS_FAIL,
  PUT_PROFESSIONS_REQUEST, PUT_PROFESSIONS_SUCCESS, PUT_PROFESSIONS_FAIL,
  DELETE_PROFESSIONS_REQUEST, DELETE_PROFESSIONS_SUCCESS, DELETE_PROFESSIONS_FAIL,
  LOAD_USER_PROFESSIONS_REQUEST, LOAD_USER_PROFESSIONS_SUCCESS, LOAD_USER_PROFESSIONS_FAIL,
  POST_USER_PROFESSIONS_REQUEST, POST_USER_PROFESSIONS_SUCCESS, POST_USER_PROFESSIONS_FAIL,
  PUT_USER_PROFESSIONS_REQUEST, PUT_USER_PROFESSIONS_SUCCESS, PUT_USER_PROFESSIONS_FAIL,
  DELETE_USER_PROFESSIONS_REQUEST, DELETE_USER_PROFESSIONS_SUCCESS, DELETE_USER_PROFESSIONS_FAIL
} from 'src/store/actions/professionsActions';

const professionsToOptions = (professions) => professions.map(({ Id, Name }) => ({ label: Name, value: Id }));

const initialState = {
  list: [],
  options: [],
  fetching: false,
  employeesProfessions: {}
};

const updateProfession = (list, profession) => list.map((prof) => prof.Id === profession.Id ? profession : prof);

const deleteProfession = (list, profession) => list.filter(({ Id }) => Id !== profession.id);

const professionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PROFESSIONS_REQUEST:
    case POST_PROFESSIONS_REQUEST:
    case PUT_PROFESSIONS_REQUEST:
    case DELETE_PROFESSIONS_REQUEST:
    case LOAD_USER_PROFESSIONS_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_PROFESSIONS_SUCCESS:
      return merge(state, {
        fetching: false,
        list: action.professions,
        options: professionsToOptions(action.professions)
      });
    case POST_PROFESSIONS_SUCCESS: {
      const newListUnsorted = [...state.list, action.profession];
      const newListSorted = Utils.arrays.sortArrayByObjectsPropertyValues(newListUnsorted, 'Name');
      return merge(state, { list: newListSorted, options: professionsToOptions(newListSorted), fetching: false });
    }
    case PUT_PROFESSIONS_SUCCESS: {
      const newListUnsorted = updateProfession(state.list, action.profession);
      const newListSorted = Utils.arrays.sortArrayByObjectsPropertyValues(newListUnsorted, 'Name');
      return merge(state, { list: newListSorted, options: professionsToOptions(newListSorted), fetching: false });
    }
    case DELETE_PROFESSIONS_SUCCESS: {
      const newList = deleteProfession(state.list, action.profession);
      return merge(state, { list: newList, options: professionsToOptions(newList), fetching: false });
    }
    case LOAD_USER_PROFESSIONS_SUCCESS: {
      const { data: { userId, professions } } = action;
      return merge(state, { employeesProfessions: { ...state.employeesProfessions, [userId]: professions } });
    }
    case POST_USER_PROFESSIONS_SUCCESS: {
      const { data: { professions, userId } } = action;
      return merge(state, {
        employeesProfessions: {
          ...state.employeesProfessions,
          [userId]: professions
        }
      });
    }
    case PUT_USER_PROFESSIONS_SUCCESS: {
      const { data: { professions, userId } } = action;
      return merge(state, {
        employeesProfessions: {
          ...state.employeesProfessions,
          [userId]: professions
        }
      });
    }
    case DELETE_USER_PROFESSIONS_SUCCESS: {
      const { data: { id, userId } } = action;
      return merge(state, {
        employeesProfessions: {
          ...state.employeesProfessions,
          [userId]: state.employeesProfessions[userId].filter((prof) => prof.Id !== id)
        }
      });
    }
    case LOAD_PROFESSIONS_FAIL:
    case POST_PROFESSIONS_FAIL:
    case PUT_PROFESSIONS_FAIL:
    case DELETE_PROFESSIONS_FAIL:
    case LOAD_USER_PROFESSIONS_FAIL:
      return merge(state, { fetching: false });
    default:
      return state;
  }
};

export default professionsReducer;
